// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2horF","label":"LabeledBox_label__3Wwk6"};